import { PULSE_COLORS } from './pulseConfig.js'

const RELEASE_CONFIG = [
    { key: 'hotfix', label: 'HOTFIX', color: '#EF4444', bg: '#7f1d1d', icon: '🔥' },
    { key: 'patch', label: 'PATCH', color: '#3B82F6', bg: '#1e3a8a', icon: '🩹' },
    { key: 'release', label: 'RELEASE', color: '#10B981', bg: '#064e3b', icon: '🚀' },
]

export default function ReleaseComparison({ hotfix, patch, release, headerAction }) {
    const values = { hotfix, patch, release }
    return (
        <div
            style={{
                background: PULSE_COLORS.cardBg,
                borderRadius: '12px',
                padding: '20px',
                border: `1px solid ${PULSE_COLORS.border}`,
            }}
        >
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '12px',
                    marginBottom: '16px',
                }}
            >
                <h3 style={{ color: PULSE_COLORS.text, fontWeight: 600, fontSize: '16px', margin: 0 }}>
                    Release Comparison
                </h3>
                {headerAction}
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '16px' }}>
                {RELEASE_CONFIG.map((r) => (
                    <div key={r.key} style={{ textAlign: 'center' }}>
                        <div style={{ fontSize: '32px', fontWeight: 700, color: r.color }}>{values[r.key]}</div>
                        <span
                            style={{
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                marginTop: '4px',
                                padding: '2px 8px',
                                borderRadius: '4px',
                                fontSize: '11px',
                                fontWeight: 600,
                                backgroundColor: r.bg,
                                color: r.color,
                            }}
                        >
                            <span>{r.icon}</span>
                            {r.label}
                        </span>
                    </div>
                ))}
            </div>
        </div>
    )
}
